// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__NMJ07 text_element__2vrEM","large":"Tooltip_large__392w-","arrow":"Tooltip_arrow__2pgPx"};